import { Divider, Flex, Text } from '@chakra-ui/react';
import RowList from '../../nesting/RowList';
import MemberLoadingCell from '../LoadingCell/MemberLoadingCell';
import type { MembersDataItem } from '../../types/team-table.types';

export default function Members({
  data,
  isLoading,
}: {
  data?: MembersDataItem[];
  isLoading: boolean;
}) {
  return (
    <Flex
      direction="column"
      position="sticky"
      left={0}
      bg="white"
      h={'fit-content'}
      maxW="240px"
      w={'fit-content'}
    >
      <Flex
        bg="#FBFBFB"
        position="sticky"
        top={0}
        align="center"
        minH="52px"
        px={4}
        zIndex={50}
      >
        <Flex w="full" align="center" justify={'center'}>
          <Flex w="full" gap={1} align="center">
            <Text
              fontSize="sm"
              fontFamily="heading"
              fontWeight="medium"
              color="text.secondary2"
              w="fit-content"
            >
              Members{' '}
            </Text>
          </Flex>
        </Flex>
      </Flex>
      <Divider />

      {isLoading ? (
        [...Array(10)].map((_, index) => <MemberLoadingCell key={index} />)
      ) : (
        <RowList key="MEMBERS" colKey="MEMBERS" rows={data} level={0} />
      )}
      <Divider />
    </Flex>
  );
}
